window.addEventListener('load', () => {
  const modalContent = document.querySelector('ample-modal');
  
  if (!modalContent) return; 

  const styleEl = document.getElementById('pwp-modal');
  if (!styleEl?.sheet) return;
 

  let cssText = '';
  for (const rule of styleEl.sheet.cssRules) {
    cssText += rule.cssText;
  }
  const sheet = new CSSStyleSheet();
  sheet.replaceSync(cssText);

  const applyStyles = () => {
    if (modalContent.shadowRoot) {
      modalContent.shadowRoot.adoptedStyleSheets = [
        ...modalContent.shadowRoot.adoptedStyleSheets,
        sheet
      ];
     
    }
  };

  const modal = modalContent.shadowRoot.querySelector('.modal.micromodal-slide');
  console.log(modal)
   if (!modal) return;
  

  const observer = new MutationObserver((mutations) => {
   
    mutations.forEach(mutation => {
      if (mutation.attributeName === 'class' && modal.classList.contains('is-open')) {
        console.log('Modal opened, applying PWP styles...');
        applyStyles();
      }
    });
  });

  observer.observe(modal, { attributes: true });
});
